import { PropsWithChildren, createContext, useContext } from 'react';

const UNMEASURED_WIDTH = 0;

const ProductDetailsListWidthContext = createContext(UNMEASURED_WIDTH);

interface ProductDetailsListWidthProviderProps {
  width: number;
}

export const ProductDetailsListWidthProvider = ({
  width,
  children,
}: PropsWithChildren<ProductDetailsListWidthProviderProps>) => (
  <ProductDetailsListWidthContext.Provider value={width}>
    {children}
  </ProductDetailsListWidthContext.Provider>
);

export const useProductDetailsListWidth = () => useContext(ProductDetailsListWidthContext);
